import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { registerSW } from '@/lib/registerSW';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Activates only in production builds (so it does not fight CRA HMR in dev).
registerSW();
